import { always, chain, cond, is, isNil, map, prop, reduce, sum, T, min as rMin, max as rMax } from 'ramda';
import { max, min } from 'd3-array';

import { PALETTE_A, PALETTE_B, PALETTE_C } from './charts.constants';

export const getSeriesDomain = ({ forceDomain = [], series, data }) => {
  const values = chain(dataPoint => map(serie => dataPoint[serie], series))(data);

  const getMinValue = () => {
    if (forceDomain && forceDomain.length > 0) {
      return forceDomain[0];
    }
    return reduce(rMin, Infinity, values);
  };

  const getMaxValue = () => {
    if (forceDomain && forceDomain.length > 1) {
      return forceDomain[1];
    }

    return reduce(rMax, -Infinity, values);
  };

  return [getMinValue() * 0.99, getMaxValue() * 1.01];
};

export const getSize = value => (is(Number, value) || !isNaN(Number(value)) ? `${value}px` : `${value}`);
export const getPosition = getSize;

export const getPropSize = (sizeProp, defaultValue) => item => {
  const value = item[sizeProp] || defaultValue;

  return getSize(value);
};

export const coloringByIndexed = palette => (...indexes) => {
  const colorIndex = sum(indexes) % palette.length;

  return palette[colorIndex];
};

export const usePaletteA = coloringByIndexed(PALETTE_A);
export const usePaletteB = coloringByIndexed(PALETTE_B);
export const usePaletteC = coloringByIndexed(PALETTE_C);

export const getMinValueInSeries = cond([
  [({ startFromZero }) => startFromZero, always(0)],
  [({ axisMin }) => !isNil(axisMin), prop('axisMin')],
  [
    T,
    ({ axisMinExtent = 1 }, { series, data = [] }) => {
      const minValue = Math.min(...series.map(serie => min(data, prop(serie))));

      return minValue * axisMinExtent;
    },
  ],
]);

export const getMaxValueInSeries = cond([
  [({ axisMax }) => !isNil(axisMax), prop('axisMax')],
  [
    T,
    ({ axisMaxExtent = 1 }, { series, data = [] }) => {
      const maxValue = Math.max(...series.map(serie => max(data, prop(serie))));

      return maxValue * axisMaxExtent;
    },
  ],
]);

export const padYDomain = ([min, max]) => {
  const padding = (max - min) * 0.1;
  const minValue = min >= 0 ? Math.max(0, min - padding) : min - padding;
  const maxValue = max + padding;

  return [minValue, maxValue];
};
